import { z } from 'zod'

// Jour calendaire 'YYYY-MM-DD' attendu par le type Doctrine `date` (bornes incluses cote API).
const isoDaySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date attendue au format YYYY-MM-DD')

/**
 * POST programme_survey_windows — ids scalaires, PAS d'IRI : resoudre l'IRI d'une enquete
 * declenche cote API le provider d'enquete (statistiques, detach/clear) et fait echouer le flush.
 */
export const surveyWindowCreateSchema = z.object({
  programmeId: z.number().int().positive(),
  surveyId: z.number().int().positive(),
  dateStart: isoDaySchema.nullable(),
  dateEnd: isoDaySchema.nullable(),
})

/** PATCH programme_survey_windows/:id — `id` resout la path variable. */
export const surveyWindowUpdateSchema = z.object({
  id: z.number(),
  dateStart: isoDaySchema.nullable(),
  dateEnd: isoDaySchema.nullable(),
})

/** DELETE programme_survey_windows/:id */
export const surveyWindowDeleteSchema = z.object({
  id: z.number(),
})
